__turbopack_context__.v({
  "content": "Lightfall-module__1D2ZVW__content",
  "lights": "Lightfall-module__1D2ZVW__lights",
  "root": "Lightfall-module__1D2ZVW__root",
});
